import React from 'react';
import 'font-awesome/css/font-awesome.css';
import '../css/footer.css'
import {FadeTransform} from 'react-animation-components';

function Footer() {
  return (
    <>
    <FadeTransform
          in
          transformProps={{
              enterTransform: 'translateY(0px)',
              exitTransform: 'translateY(100px)'
          }}
      >
        <footer className="footer">
            <div className="footer text-center text-white">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fill-opacity="1" d="M0,192L40,181.3C80,171,160,149,240,160C320,171,400,213,480,229.3C560,245,640,235,720,218.7C800,203,880,181,960,149.3C1040,117,1120,75,1200,58.7C1280,43,1360,53,1400,58.7L1440,64L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"></path></svg>
                <div className="container p-4 pb-0">
                    <div className="text-center">
                        <div className="col-12">
                            <h3>Portfolio Webiste</h3>
                            <br/>
                        </div>
                        <div className="col-12">
                            {/* <a className="btn btn-outline-light btn-floating m-1" href="https://www.facebook.com/profile.php?id=100083387141433" role="button"><i className="fa fa-facebook fa-lg"></i></a>
                            <a className="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i className="fa fa-twitter fa-lg"></i></a>
                            <a className="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i className="fa fa-google fa-lg"></i></a>
                            <a className="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i className="fa fa-instagram fa-lg"></i></a>
                            <a className="btn btn-outline-light btn-floating m-1" href="https://www.linkedin.com/in/devanshu-dalal-3042a1219/" role="button"><i className="fa fa-linkedin fa-lg"></i></a>
                            <a className="btn btn-outline-light btn-floating m-1" href="https://github.com/devanshukd04" role="button"><i className="fa fa-github fa-lg"></i></a> */}
                            <a className="btn text-white btn-floating m-1" style={{backgroundColor: "#55acee"}} href="https://www.facebook.com/profile.php?id=100083387141433" role="button" ><i className="fa fa-facebook fa-lg"></i></a>
                            <a className="btn text-white btn-floating m-1" style={{backgroundColor: "#55acee"}} href="#!" role="button" ><i className="fa fa-twitter fa-lg"></i></a>
                            <a className="btn text-white btn-floating m-1" style={{backgroundColor: "#dd4b39"}} href="mailto:devanshukd27@gmail.com" role="button"><i class="fa fa-google fa-lg"></i></a>
                            <a className="btn text-white btn-floating m-1" style={{backgroundColor: "#ac2bac"}} href="#!"role="button"><i class="fa fa-instagram fa-lg"></i></a>
                            <a className="btn text-white btn-floating m-1" style={{backgroundColor: "#0082ca"}} href="https://www.linkedin.com/in/devanshu-dalal-3042a1219/" role="button"><i class="fa fa-linkedin fa-lg"></i></a>
                            <a className="btn text-white btn-floating m-1" style={{backgroundColor: "#333333"}} href="https://github.com/devanshukd04" role="button"><i class="fa fa-github fa-lg"></i></a>
                        </div>
                        
                    </div>
                   
                </div>
                
            </div>

        </footer>
        </FadeTransform>

        {/* <footer class="bg-light text-center text-white">
            <div class="container p-4 pb-0">
                <section class="mb-4">
                    <a class="btn text-white btn-floating m-1" style="background-color: #3b5998;" href="#!" role="button"><i class="fab fa-facebook-f"></i></a>
                    <a class="btn text-white btn-floating m-1" style="background-color: #55acee;" href="#!" role="button" ><i class="fab fa-twitter"></i></a>

                    <a class="btn text-white btn-floating m-1" style="background-color: #dd4b39;" href="#!" role="button"><i class="fab fa-google"></i></a>

                    <a class="btn text-white btn-floating m-1" style="background-color: #ac2bac;"href="#!"role="button"><i class="fab fa-instagram"></i></a>


                    <a class="btn text-white btn-floating m-1" style="background-color: #0082ca;" href="#!" role="button"><i class="fab fa-linkedin-in"></i></a>
                    <a class="btn text-white btn-floating m-1" style="background-color: #333333;" href="#!" role="button"><i class="fab fa-github"></i></a>
                </section>
            </div>

            <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2);">
                <a class="text-white" href="https://mdbootstrap.com/">MDBootstrap.com</a>
            </div>
            </footer> */}

        {/* <footer class="bg-dark text-center text-white">
            <div class="container p-4">
                <section class="mb-4">
                <a class="btn btn-outline-light btn-floating m-1" href="https://www.facebook.com/profile.php?id=100083387141433" role="button"><i class="fa fa-facebook fa-lg"></i></a>
                <a class="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i class="fa fa-twitter fa-lg"></i></a>
                <a class="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i class="fa fa-google fa-lg"></i></a>
                <a class="btn btn-outline-light btn-floating m-1" href="#!" role="button"><i class="fa fa-instagram fa-lg"></i></a>
                <a class="btn btn-outline-light btn-floating m-1" href="https://www.linkedin.com/in/devanshu-dalal-3042a1219/" role="button"><i class="fa fa-linkedin fa-lg"></i></a>
                <a class="btn btn-outline-light btn-floating m-1" href="https://github.com/devanshukd04" role="button"><i class="fa fa-github fa-lg"></i></a>
                
                </section>
                <section class="">
                <form action="">
                    <div class="row d-flex justify-content-center">
                    <div class="col-auto">
                        <p class="pt-2">
                        <strong>Sign up for our newsletter</strong>
                        </p>
                    </div>
                    <div class="col-md-5 col-12">
                        <div class="form-outline form-white mb-4">
                        <input type="email" id="form5Example21" class="form-control" />
                        <label class="form-label" for="form5Example21">Email address</label>
                        </div>
                    </div>
                    <div class="col-auto">
                        <button type="submit" class="btn btn-outline-light mb-4">
                        Subscribe
                        </button>
                    </div>
                    </div>
                </form>
                </section>
                <section class="mb-4">
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt distinctio earum
                    repellat quaerat voluptatibus placeat nam, commodi optio pariatur est quia magnam
                    eum harum corrupti dicta, aliquam sequi voluptate quas.
                </p>
                </section>
                <section class="">
                <div class="row">
                    <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
                    <h5 class="text-uppercase">Links</h5>

                    <ul class="list-unstyled mb-0">
                        <li>
                        <a href="#!" class="text-white">Link 1</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 2</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 3</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 4</a>
                        </li>
                    </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
                    <h5 class="text-uppercase">Links</h5>

                    <ul class="list-unstyled mb-0">
                        <li>
                        <a href="#!" class="text-white">Link 1</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 2</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 3</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 4</a>
                        </li>
                    </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
                    <h5 class="text-uppercase">Links</h5>

                    <ul class="list-unstyled mb-0">
                        <li>
                        <a href="#!" class="text-white">Link 1</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 2</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 3</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 4</a>
                        </li>
                    </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
                    <h5 class="text-uppercase">Links</h5>

                    <ul class="list-unstyled mb-0">
                        <li>
                        <a href="#!" class="text-white">Link 1</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 2</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 3</a>
                        </li>
                        <li>
                        <a href="#!" class="text-white">Link 4</a>
                        </li>
                    </ul>
                    </div>
                </div>
                </section>
            </div>
            <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2);">
                © 2020 Copyright:
                <a class="text-white" href="https://mdbootstrap.com/">MDBootstrap.com</a>
            </div>
        </footer> */}
    </>
  );
}

export default Footer